/**
 * YouTube Icon
 * 
 * Uses Font Awesome under the hood for maintained, up-to-date brand icons.
 */

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import type { IconProps } from '../../types';

export function YouTubeIcon({ 
  className, 
  size = 24, 
  color,
  'aria-label': ariaLabel = 'YouTube',
}: IconProps) {
  return (
    <FontAwesomeIcon 
      icon={faYoutube}
      className={className}
      style={{ 
        width: typeof size === 'number' ? size : undefined,
        height: typeof size === 'number' ? size : undefined,
      }}
      color={color}
      aria-label={ariaLabel}
      role="img"
    />
  );
}
